var _mask, _path, _path2, _mask2, _rect, _path3, _mask3, _rect2, _mask4, _rect3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMixedUse = function SvgMixedUse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 38"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mixed-use_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 23.43a.43.43 0 0 1 .43-.43h5.64a.43.43 0 0 1 .43.43v13.141a.43.43 0 0 1-.429.429H18.43a.43.43 0 0 1-.429-.429z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 23.43c0-.79.64-1.43 1.43-1.43h5.64c.79 0 1.43.64 1.43 1.43l-2 .57H19zM24.5 37H18zm-6.071 0c-.79 0-1.429-.64-1.429-1.429V23.43c0-.79.64-1.43 1.43-1.43l.57 2v13zm5.641-15c.79 0 1.43.64 1.43 1.43v12.141c0 .79-.64 1.429-1.429 1.429H23.5V24z",
    mask: "url(#mixed-use_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "m13.786 19.5-.786 4v13.786h23.857V23.5l-1-4z"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mixed-use_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    x: 28,
    y: 26.5,
    rx: 0.383
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    x: 28,
    y: 26.5,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#mixed-use_svg__b)",
    rx: 0.383
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M14.786 4 12.5 7.929H14V19.5h21.857V7.929H37L34.857 4z"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mixed-use_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    x: 18,
    y: 10.5,
    rx: 0.383
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    x: 18,
    y: 10.5,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#mixed-use_svg__c)",
    rx: 0.383
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mixed-use_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    x: 26.5,
    y: 10.5,
    rx: 0.383
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    x: 26.5,
    y: 10.5,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#mixed-use_svg__d)",
    rx: 0.383
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M14 7.9h22M13 23.5h23.5"
  })));
};
export default SvgMixedUse;